import { render, staticRenderFns } from "./FormCaptcha.vue?vue&type=template&id=667e5c48&scoped=true&"
import script from "./FormCaptcha.vue?vue&type=script&lang=js&"
export * from "./FormCaptcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667e5c48",
  null
  
)

export default component.exports